import React from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'

import { DeleteReasonDropdown, Option } from './DeleteReasonDropdown'
import { Dialog } from '@carsys/ui'

interface ConfirmationDialogProps {
  deletedItemString: string
  deleteReasons?: Option[]
  onConfirm: (reason?: string) => void
  onCancel: () => void
  reasonIsRequired: boolean
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { t } = useTranslation()
  const [deleteReason, setDeleteReason] = React.useState<string | undefined>(undefined)

  const reasonIsSelected = Boolean(deleteReason)

  return (
    <Dialog fullWidth open>
      <DialogTitle>{t('DeleteFlow.ConfirmationDialog.Title', { item: props.deletedItemString })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('DeleteFlow.ConfirmationDialog.Description', { item: props.deletedItemString })}</DialogContentText>
        {props.deleteReasons ? (
          <DeleteReasonDropdown
            deletedItemString={props.deletedItemString}
            onChange={setDeleteReason}
            options={props.deleteReasons}
            value={deleteReason}
            reasonIsRequired={props.reasonIsRequired}
          />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' color='primary' onClick={props.onCancel}>
          {t('DeleteFlow.ConfirmationDialog.Cancel')}
        </Button>
        <Button
          color='primary'
          disabled={props.reasonIsRequired && !reasonIsSelected}
          onClick={() => props.onConfirm(deleteReason)}
          startIcon={<Delete />}
          variant='contained'
          autoFocus
          sx={{
            '&:hover,&:focus': {
              backgroundColor: 'primary.dark'
            }
          }}
        >
          {t('DeleteFlow.ConfirmationDialog.Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
